import React, { Component } from 'react';
import { Card, Elevation, Spinner } from "@blueprintjs/core";
import Loads, { createLoader } from 'react-loads'
import Loading from '../../Shared/LoadingCharts'
import Title from '../../Shared/TitleChart'
import Reload from '../../Shared/ReloadChart'
import Error from '../../Shared/ErrorChart'
import moment from 'moment'
import _ from 'lodash'
import numeral from 'numeral'

import { Colors } from '../../../config'
import Chart from '../../Shared/Chart'
import Color from 'color'

import axios from '../../../services/axios'
import storage from '../../../services/storage'

import LoadingMind from '../../Shared/LoadingMind'

import './styles.css'

class Journey extends Component {
  constructor(props){
    super(props);
    this.state = {
      data: {
        columns: [],
        rows: [],
        serialized: [{}]
      }
    }

    this.reload = 0
    this.success = this.success.bind(this)
    this.error = this.error.bind(this)
    this.loading = this.loading.bind(this)

    this.chart = this.chart.bind(this)
    this.getData = this.getData.bind(this)
  }

  getData(range){
    const since = moment(range[0]).format('YYYY-MM-DD')
    const until = moment(range[1]).format('YYYY-MM-DD')
    
    return storage.get('page')
    .then((page)=>{
      if(window.location.hostname == 'smartintel.io' && page == 85){
        return Promise.all([
          axios.get(`${page}/analytics/google/query`, {
            params: {
              since,
              until,
              metrics: 'ga:sessions, ga:productDetailViews, ga:productCheckouts, ga:productAddsToCart, ga:transactions'
            }
          }),
          axios.get(`${page}/analytics/google/convertions`, {
            params: {
              since,
              until            
            }
          })
        ]).then((data)=>{
          return {
            analytics: data[0].data.data,
            goal: data[1].data.data
          }
        })
      }else{
        return axios.get(`${page}/analytics/google/query`, {
          params: {
            since,
            until,
            metrics: 'ga:sessions, ga:productDetailViews, ga:productCheckouts, ga:productAddsToCart, ga:transactions'
          }
        }).then((response)=>{
          return {
            analytics: response.data.data
          }
        })
      }
    })
  }

  chart(data){
    const isGoal = _.has(data, 'goal')
    const { serialized, columns, rows } = data.analytics  

    const custom =  _.map(rows[0], (item, index)=>{
      const { length } = rows[0]
      const background = Colors[index]
      const color = Color(background)
      let abandon = 0

      const name = isGoal && index == length - 1 ? data.goal.goalName : columns[index]
      const value = isGoal && index == length - 1 ? data.goal.Events : item

      if(index != 0){
        abandon = (rows[0][index] / rows[0][index - 1]) * 100
        abandon = numeral(abandon).format('0,0[.]00')
      }
      
      return {
        'plot-rules': {
          rule: `%p==${index}`,
          backgroundColor: background,
          borderColor: background,
        },
        'value-box-lables': {
          rule: `%p==${index}`,
          fontColor: color.isLight() ? '#36383a' : '#ffffff',
          text: `<span style='font-size: 10px'>${name}: ${numeral(value).format('0,0[.]00')}\n${index != 0 ? `Adandon Rate: ${abandon}%` : ''}</span>`
        }
        /*'plot-labels': {
          rule: `%i==${index}`,
          borderColor: Colors[index],
          text: `<span style="font-weight:bold"><div style="width: 10px; height: 10px; background-color: ${Colors[index]}; display: inline-block"></div> ${item[0]}: ${numeral(item[3]).format('0,0[.]00')}%</span>`
        }*/
      }
    })

    let config = {
      type: 'funnel',
      backgroundColor: '#363737',
      gui: {
        behaviors: [{
          id: 'ViewSource',
          enabled: 'none'
        },{
          id: 'HideGuide',
          enabled: 'none'
        },{
          id: 'Reload',
          enabled: 'none'
        },{
          id: 'Reload',
          enabled: 'none'
        },{
          id: 'ViewAsPng',
          enabled: 'none'
        },{
          id: 'ViewDataTable',
          enabled: 'none'
        }]
      },
      globals: {
        fontFamily: 'Helvetica'
      },
      plotarea:{ 
        backgroundColor : '#363737',
        adjustLayout: true,
        margin: 0,
        padding: 0,
        width: '124%',
        x: '-24'
      },
      scaleY: {
        margin: 0,
        padding: 0,
        lineStyle: 'solid',
        thousandsSeparator: ',',
        lineColor: '#4a4a4a',
        lineWidth: '.5px',
        visible: false,
        tick: {
          lineColor: 'none'
        },
        guide: {
          visible: false,
          lineStyle: 'solid',
          lineColor: '#4a4a4a',
          lineWidth: '.5px'
        },
        item: {
          color: '#FFFFFF',
          fontSize: '0px'
        }
      },
      scaleX: {
        margin: 0,
        padding: 0,
        offset: '0px',
        maxItems: 20,
        lineStyle: 'solid',
        lineColor: '#4a4a4a',
        lineWidth: '.5px',
        visible: false,
        tick: {
          lineColor: 'none'
        },
        guide: {
          visible: false,
          lineStyle: 'solid',
          lineColor: '#4a4a4a',
          lineWidth: '.5px'
        },
        item: {
          color: '#FFFFFF'
        }
      },
      plot: {
        cursor: 'hand',
        minExit: '30%',
        rules: _.map(custom, 'plot-rules'),
        valueBox: {
          text: '%v',
          placement: 'in',
          fontColor: '#FFFFFF',
          rules: _.map(custom, 'value-box-lables'),
        }
      },
      tooltip: {
        visible: false,
        text: '%v',
        multiple: true,
        fontSize: '12px',
        color: '#FFFFFF',
        backgroundColor: '#000',
        borderWidth: 0,
        alpha: 0.6,
        callout: true,
        calloutPosition: 'bottom',
        shadow: 0,
        borderRadius: 4,
        //rules: _.map(custom, 'plot-labels'),
        placement: 'node:top',
        calloutPosition: 'bottom',
        offsetY: 8
      },
      series: [
        {"values": [5]},
        {"values": [4]},
        {"values": [3]},
        {"values": [2]},
        {"values": [1]}
      ]
    }

    return (
      <Chart 
        width="100%" 
        height="420px"
        output="canvas"
        data={config} 
      />
    )
  }

  success({ response, load }){
    const data =  response
    const Chart = this.chart(data)

    return (
      <div>{Chart}</div>
    )
  }

  error({ error, load }){
    switch(true){
      case this.reload < 6:
        this.reload++
        load()
        return (<Loading />)
      break

      case this.reload < 10:
        return (<Reload onReload={()=>{
          this.reload++
          load()
        }} />)
      break

      case this.reload > 9:
        return (<Error 
          error={error.message} 
        />)
      break
    }
  }

  shouldComponentUpdate(props){
    return !_.isEqual(this.props, props)
  }

  loading(){
    return (
      <Loading />
    )
  }

  render () {
    const Chart = createLoader({
      load: () => this.getData(this.props.range)
    })

    return(
      <Card 
        interactive={false} 
        elevation={Elevation.TWO} 
        id='googleJourney'
        className="no-pad-t-b">
        <Title title='Purchase Journey' />
        <div className="googleJourneyContainer">
          <Chart loadOnMount>
            <Chart.Loading>
              {this.loading()}
            </Chart.Loading>
            <Chart.Success>
              {this.success}
            </Chart.Success>
            <Chart.Error>
              {this.error}
            </Chart.Error>
          </Chart>
        </div>
      </Card>
    )
  }
}

export default Journey



// WEBPACK FOOTER //
// ./src/components/WebIntelligence/Journey/index.js